import React from 'react';
import { arrayOf, object } from 'prop-types';
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableContainer,
} from '@mui/material';

import staticText from '../../../../../../../../../../../../localization/Application/Simulator/simulator';
import { ArrowLink, Chip } from '../../../../../../../../../../../../components';

const LatencyTable = ({ endpointData }) => {
  return (
    <React.Fragment>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{staticText.brandLatencies.method}</TableCell>
              <TableCell>{staticText.brandLatencies.endpoint}</TableCell>
              <TableCell>{staticText.brandLatencies.range}</TableCell>
              <TableCell>{staticText.brandLatencies.median}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {endpointData.map((endpoint) => {
              const latencyRange = `${endpoint.latencyLowerBound} - ${endpoint.latencyUpperBound}`;
              const latencyAverage =
                ((endpoint.latencyUpperBound - endpoint.latencyLowerBound) / 2) +
                endpoint.latencyLowerBound;
              if (latencyAverage === 0) return null;
              return (
                <TableRow key={`${endpoint.method}-${endpoint.path}`}>
                  <TableCell>
                    <Chip key={endpoint.method} label={endpoint.method} type={endpoint.method === 'GET' ? 'get' : 'post'} />
                  </TableCell>
                  <TableCell>{`/${endpoint.path.split('/')[1]}${endpoint.path.split('/')[2] ? `/${endpoint.path.split('/')[2]}` : ''}`}</TableCell>
                  <TableCell>{`${latencyRange} seconds`}</TableCell>
                  <TableCell>{`${latencyAverage} seconds`}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <ArrowLink
        link={staticText.brandLatencies.footnote.link}
        text={staticText.brandLatencies.footnote.text}
      />
    </React.Fragment>
  );
};

export default LatencyTable;

LatencyTable.propTypes = {
  endpointData: arrayOf(object).isRequired,
};
